import { getChildrenItems } from 'qwanyx/qwanyx-core/api-client';

export async function getCards(stackId, recursive = true) {
    try {
        const allCards = [];
        const processedIds = new Set();

        async function fetchCardsRecursive(currentStackId) {
            if (processedIds.has(currentStackId)) return;
            processedIds.add(currentStackId);

            // Use API client to get children
            const cards = await getChildrenItems(currentStackId);

            allCards.push(...cards);

            if (recursive) {
                for (const card of cards) {
                    await fetchCardsRecursive(card._id);
                }
            }
        }

        await fetchCardsRecursive(stackId);
        return allCards;

    } catch (error) {
        console.error("Error fetching cards from Qwantas:", error);
        throw error;
    }
}